module.exports = __webpack_public_path__ + "static/img/404.4fb0887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/404.png
// module id = tE/j
// module chunks = 11